import {Pipe, PipeTransform} from '@angular/core';
import {TrackerCandidateStatus} from '../../model';
import {trackerCandidateStatusForId} from '../../utils';

@Pipe({name: 'trackerStatus'})
export class TrackerStatusPipe implements PipeTransform {

  transform(input: Submittal[], status: TrackerCandidateStatus): Submittal[] {
    return input ? input.filter(s => trackerCandidateStatusForId(s.statusId) === status) : [];
  }
}
